import styled from 'styled-components';

export const LoadingWrap = styled.div`
  display: flex;
  justify-content: center;
  padding: 64px 0;
`;
